export const EDIT_SUCCESS = 'Банк обновлен';
export const EDIT_ERROR = 'Не удалось обновить банк';
